export default {
    getEbeutaloTableAdditionalConfig: state => state.eBeutaloTableAdditionalConfig,
    getEbeutaloSearchFields: state => state.eBeutaloSearchFields,
    getEbeutaloTableHeaderFields: state => state.eBeutaloTableHeaderFields,
    getEbeutaloHeaderFields: state => state.eBeutaloHeaderFields,
    getExpenditureFormHeaderFields: state => state.expenditureFormHeaderFields,
    getFormActionsEbeutalo: state => state.eBeutaloFormActions,
    getActionsEbeutalo: state => state.eBeutaloActions,
    getActionsEbeutaloEkat: state => state.eBeutaloEkatActions,
    getRowActionsEbeutalo: state => state.eBeutaloRowActions,
    getRowActionsEBeuEKat: state => state.eBeutaloEKatRowActions,

    isGridShow: state => state.gridIsShow,
    isFormShow: state => state.formIsShow,
    isExpenditureFormShow: state => state.expenditureForm
}